<style lang="less" scoped>
  @import "../../vars.less";

  .base-info {
    position: relative;
    padding: @space-normal;
    padding-left: calc(@space-normal + 4px);
    margin-bottom: @space-small;
    background-color: #fff;
    color: @text-color;
    font-size: 14px;
  }
  .title-container {
    display: flex;
    color: @text-color-important;
  }
  .title {
    flex: auto;
    font-size: 16px;
    font-weight: bold;
  }
  .title-right {
    flex: none;
    align-self: right;
    display: flex;
    justify-content: center;
    .icon {
      font-size: 20px;
      margin-right: @space-small;
    }
  }
  .done {
    .title-right {
      color: @primary-color;
    }
    .status-bar {
      background-color: @primary-color;
    }
  }
  .underway {
    .title-right {
      color: @warning-color;
    }
    .status-bar {
      background-color: @warning-color;
    }
  }
  .status-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
  }
  .content {
    margin-top: @space-normal;
    padding-bottom: @space-medium;
  }
  .content-item {
    margin: 0;
    display: flex;
    line-height: 1.8;
  }
  .label {
    flex: none;
    color: @text-color-secondary;
    margin-right: @space-normal;
  }
  .label:after {
    content: ":"
  }
  .value {
    flex: auto;
  }
  .extra {
    padding-top: @space-medium;
  }
  .extra-item {
    display: inline-flex;
    align-items: center;
  }
  .extra-item ~ .extra-item {
    margin-left: @space-large;
  }
  .extra-icon {
    width: 20px;
    margin-right: @space-small;
  }
  .extra-text {
    font-size: 14px;
    color: @text-color-secondary;
  }
  .material-list {
    margin-top: @space-normal;
    padding: @space-normal;
    font-size: 12px;
    line-height: 1.8;
    background-color: #fff;
  }
  .material-item:not(:last-child) {
    padding-bottom: @space-medium;
    margin-bottom: @space-medium;
  }
  // .material-item:last-child:after {
  //   display: none;
  // }
  .material-title {
    margin: 0 0 @space-small 0;
    color: @primary-color;
    font-size: 14px;
    font-weight: 500;
  }
  .material-line {
    display: flex;
    justify-content: center;
    margin: 0;
  }
  .material-line-left {
    flex: auto;
  }
  .material-line-right {
    flex: none;
  }
  .secondary {
    color: @text-color-secondary !important;
  }
  .comment-line {
    margin: 0;
  }
  .actions {
    display: flex;
    margin-top: @space-medium;
  }
  .other-info-link {
    flex: auto;
    color: @text-color;
    background-color: @background-color;
    font-size: 14px;
    text-align: center;
    padding: @space-small;
    &:not(:last-child) {
      margin-right: @space-normal;
    }
  }
  .collapse-handler {
    // padding:
    text-align: center;
    font-size: 14px;
    padding-top: @space-small;
  }
  .footer {
    padding: @space-medium @space-normal;
    background-color: #fff;
    height: 100%;
    display: flex;
    align-items: stretch;
    & > *:not(:last-child) {
      margin-right: @space-normal;
    }
  }
  .collect {
    flex: auto;
    color: @primary-color;
    font-size: 28px;
  }
  .link {
    color: @primary-color !important;
    .input {
      color: @primary-color !important;
    }
  }
  .divider {
    color: @primary-color;
    border-color: @primary-color;
    margin: @space-small;
  }
</style>
<style lang="less">
  @import "../../vars.less";

  .field-link.van-cell--clickable {
    * {
      color: @primary-color !important;
    }
  }
</style>

<template>
  <page-container class="order-detail" title="订单详情" :loading="!!loading">
    <div class="base-info">
      <div class="status-bar" />
      <div class="title-container">
        <span class="title">
          {{ $t('SO') }}: {{ $route.query.orderNumber }}
        </span>
        <span class="title-right" v-if="!loading">
          <van-icon v-if="detail.order_status == 1" name="passed" class="icon"/>
          <van-icon v-if="detail.order_status == 2" name="underway-o" class="icon"/>
          {{ detail.order_status == 2 ? $t('未完成') : $t('已完成') }}
        </span>
      </div>
      <div class="content van-hairline--bottom">
        <p class="content-item">
          <span class="label">{{ $t('客户名称') }}</span>
          <span class="value">{{ detail.cust_name }}</span>
        </p>
        <p class="content-item">
          <span class="label">{{ $t('客户订单号') }}</span>
          <span class="value">{{ detail.cust_order_number }}</span>
        </p>
        <p class="content-item">
          <span class="label">{{ $t('销售订单时间') }}</span>
          <span class="value">{{ detail.order_date ? detail.order_date.replace('T', ' ') : '' }}</span>
        </p>
      </div>
      <div class="extra">
        <div class="extra-item">
            <img class="extra-icon"
              :src="`/images/shield${detail.credit_block ? '' : '-disabled'}.svg`"/>
            <span class="extra-text">{{ $t('信用锁定') }}</span>
          </div>
          <div class="extra-item">
            <img class="extra-icon"
              :src="`/images/shield${detail.delivery_block ? '' : '-disabled'}.svg`"/>
            <span class="extra-text">{{ $t('发货锁定') }}</span>
          </div>
          <div class="extra-item">
            <img class="extra-icon"
              :src="`/images/shield${detail.zmin_block ? '' : '-disabled'}.svg`"/>
            <span class="extra-text">{{ $t('ZMIN锁定') }}</span>
          </div>
      </div>
    </div>
    <ul class="material-list">
      <!-- <li
        v-for="(item, index) of (collapsable && collapsed ? items.slice(0, 1) : items)"
        :key="item.material_number"
        class="material-item"
        :class="index == items.length - 1 ? '' : 'van-hairline--bottom'"> -->
      <li v-for="shit of realShits" :key="shit.orderItem + '_' + shit.materialNumber"
        class="material-item van-hairline--bottom">
        <h4 class="material-title">{{ shit.orderItem }}</h4>
        <p class="material-line">
          <span class="material-line-left link" @click="() => go2StockQuery(shit.materialNumber)">
            {{ $t('物料号') }}: {{ shit.materialNumber }}
          </span>
          <material-status class="material-line-right" :value="shit.itemstatus"/>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('物料描述') }}: {{
            shit.materialDescription ? shit.materialDescription.split('\\')[0] : ''
          }}</span>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('西门子订货号') }}: {{ shit.mlfb }}</span>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('需求数量') }}: {{ shit.itemQuantity }}</span>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('期望交货时间') }}: {{ shit.expArrivalDate }}</span>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('预计到达西门子仓库时间') }}: {{ shit.estArrivalDate }}</span>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('物料类型') }}: {{ shit.itemCategory }}</span>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('采购订单号') }}: {{ shit.purchaseOrder }}</span>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('拒绝原因') }}: {{ shit.rejection }}</span>
        </p>
        <div class="actions" v-show="!collapsed">
          <span class="other-info-link" @click="() => startShowDelivery(shit.orderItem)">{{ $t("发货单详情") }}</span>
          <span class="other-info-link" @click="() => startShowInvoice(shit.orderItem)">{{ $t("发票详情") }}</span>
          <!-- <span class="other-info-link">{{ $t("库存查询") }}</span> -->
          <span class="other-info-link secondary">{{ $t("物流明细") }}</span>
        </div>
      </li>
      <div v-show="shits.length" class="collapse-handler" @click="() => collapsed = !collapsed">
        {{ collapsed ? $t('更多') : $t('收起') }}
        <van-icon :name="collapsed ? 'arrow-down' : 'arrow-up' " />
      </div>
    </ul>

    <modal v-model="showDelivery" :title="$t('发货单详情')" :loading="deliveryLoading">
      <div v-for="(item, index) of deliveries" :key="item.deliveryNumber">
        <van-form label-align="right" label-width="45%">
          <van-field readonly :label="$t('销售订单行号')" :value="item.orderItem" />
          <van-field readonly :label="$t('发货单号')" :value="item.deliveryNumber" is-link class="field-link" @click="() => go2LogisticsQueryResultPage(item.deliveryNumber)"/>
          <van-field readonly :label="$t('发货单行号')" :value="item.deliveryItem" />
          <van-field readonly :label="$t('发货数量')" :value="item.deliveryQuantity" />
          <van-field readonly :label="$t('发货单创建日期')" :value="item.deliveryCreateDate" />
          <van-field readonly :label="$t('系统完成发货时间')" :value="item.pgiDate" />
        </van-form>
        <van-divider class="divider" v-if="index !== deliveries.length - 1"/>
      </div>
      <oh-empty v-if="!deliveryLoading && !deliveries.length" :message="$t('暂无发货单信息')"/>
    </modal>
    <modal v-model="showInvoice" :title="$t('发票详情')" :loading="invoiceLoading">
      <div v-for="(item, index) of invoices" :key="item.invoiceNumber">
        <van-form label-align="right" label-width="40%">
          <van-field readonly :label="$t('销售订单行号')" :value="item.invoiceItem"/>
          <van-field readonly :label="$t('发票号')" :value="item.invoiceNumber"/>
          <!-- <van-field readonly :label="$t('发票行号')" :value="item.invoiceItem"/> -->
          <van-field readonly :label="$t('发票数量')" :value="item.invoiceQuantity"/>
          <van-field readonly :label="$t('发票创建日期')" :value="item.invoiceCreationDate"/>
          <van-field readonly :label="$t('发票发行日期')" :value="item.invoiceReleaseDate"/>
        </van-form>
        <van-divider class="divider" v-if="index !== invoices.length - 1"/>
      </div>
      <oh-empty v-if="!invoiceLoading && !invoices.length" :message="$t('暂无发票信息')"/>
    </modal>

    <div class="footer van-hairline--top" slot="footer">
      <div class="collect" @click="toggleFavor">
        <van-icon v-show="!detail.IsFavorite" name="star-o" size="1em" />
        <van-icon v-show="detail.IsFavorite" name="star" size="1em" />
      </div>
      <template v-if="detail.order_status == '2' && ($auth('SpecialLogistics_Apply') || $auth('GreenChannelUrgentOrder_Apply'))">
        <van-button v-if="$auth('SpecialLogistics_Apply')" size="small" round type="info" @click="go2specialDeliveryApply">
          {{ $t('特殊发货') }}
        </van-button>
        <van-button v-if="$auth('GreenChannelUrgentOrder_Apply')" size="small" round type="info" @click="go2urgentOrderApply">
          {{ $t('订单加急') }}
        </van-button>
      </template>
    </div>
  </page-container>
</template>

<script>
import { Icon, Button, Form, Field, Divider, Toast } from 'vant'
import PageContainer from '../../components/PageContainer'
import MaterialStatus from '../../components/MaterialStatus'
import Empty from '../../components/Empty'
import Modal from '../../components/Modal'

const successToast = (message) => {
  return Toast({
    message,
    type: 'success',
    icon: 'success'
  })
}

export default {
  name: 'order-detail',
  components: {
    PageContainer,
    MaterialStatus,
    Modal,
    'van-icon': Icon,
    'van-button': Button,
    'van-form': Form,
    'van-field': Field,
    'oh-empty': Empty,
    'van-divider': Divider
  },
  data () {
    return {
      collapsed: true,
      showDelivery: false,
      showInvoice: false,
      detail: {},
      shits: [],
      loading: 0,
      deliveries: [],
      deliveryLoading: false,
      invoices: [],
      invoiceLoading: false,
      favorLoading: false
    }
  },
  computed: {
    realShits () {
      if (this.collapsed) return this.shits.slice(0, 1)
      else return this.shits
    }
  },
  methods: {
    getDetail () {
      this.$apis.order.getDetail(
        this.$route.query.orderNumber,
        loading => loading ? this.loading++ : this.loading--
      ).then(res => {
        if (res) this.detail = res
      })
    },
    getMaterials () {
      this.$apis.order.getMaterials(
        this.$route.query.orderNumber,
        loading => loading ? this.loading++ : this.loading--
      ).then(res => {
        if (res) this.shits = res
      })
    },
    getDelivery (orderItem) {
      this.$apis.order.getDelivery(
        this.$route.query.orderNumber,
        orderItem,
        loading => (this.deliveryLoading = loading)
      ).then(res => {
        if (res) this.deliveries = res
      })
    },
    getInvoice (orderItem) {
      this.$apis.order.getInvoice(
        this.$route.query.orderNumber,
        orderItem,
        loading => (this.invoiceLoading = loading)
      ).then(res => {
        if (res) this.invoices = res
      })
    },
    startShowDelivery (orderItem) {
      this.deliveries = []
      this.showDelivery = true
      this.getDelivery(orderItem)
    },
    startShowInvoice (orderItem) {
      this.invoices = []
      this.showInvoice = true
      // console.log('fuck')
      this.getInvoice(orderItem)
    },
    go2LogisticsQueryResultPage (deliveryNumber) {
      this.$router.push({
        name: 'logistics-query-result',
        query: { deliveryNumber },
        params: { stackType: 'push' }
      })
    },
    go2specialDeliveryApply () {
      this.$router.push({
        name: 'special-delivery-apply',
        query: {
          orderNumber: this.$route.query.orderNumber
        },
        params: { stackType: 'push' }
      })
    },
    go2urgentOrderApply () {
      this.$router.push({
        name: 'urgent-order-apply',
        query: {
          orderNumber: this.$route.query.orderNumber
        },
        params: { stackType: 'push' }
      })
    },
    toggleFavorErrorHandler () {
      this.detail.IsFavorite = this.originFavor
      return true
    },
    toggleFavor () {
      if (this.favorLoading) return
      this.originFavor = this.detail.IsFavorite
      this.detail.IsFavorite = !this.originFavor

      if (this.originFavor) {
        this.$apis.order.removeFavorite(
          this.detail.order_number,
          loading => (this.favorLoading = loading),
          {
            onBusinessError: () => this.toggleFavorErrorHandler(),
            onError: () => this.toggleFavorErrorHandler()
          }
        ).then(res => {
          if (res) successToast(this.$t('取消收藏成功'))
        })
      } else {
        this.$apis.order.setFavorite(
          this.detail,
          loading => (this.favorLoading = loading),
          {
            onBusinessError: () => this.toggleFavorErrorHandler(),
            onError: () => this.toggleFavorErrorHandler()
          }
        ).then(res => {
          if (res) successToast(this.$t('收藏成功'))
        })
      }
    },
    go2StockQuery (materialNumber) {
      this.$router.push({
        name: 'stock-query-result',
        query: { number: materialNumber, mode: 'material' },
        params: {
          stackType: 'push'
        }
      })
    }
  },
  mounted () {
    this.getDetail()
    this.getMaterials()
  }
}
</script>
